module.exports = __webpack_public_path__ + "static/img/OM12.d73015da.png";